import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from 'utils/formatter';
import styles from './Summary.css';

class Summary extends React.Component {
  render() {
    const { totalTransactions, totalCollected, netSales } = this.props;
    return (
      <div className={`${styles['summary-data-box']} visible-md visible-lg`}>
        <div className="row">
          <div className="col-xs-4">
            <div className={styles.amount}>{totalTransactions}</div>
            <div className={styles['title-center']}>Transactions</div>
          </div>
          <div className="col-xs-4">
            <div className={styles.amount}>
              {currencyFormatter(totalCollected)}
            </div>
            <div className={styles['title-center']}>Total Collected</div>
          </div>
          <div className="col-xs-4">
            <div className={styles.amount}>{currencyFormatter(netSales)}</div>
            <div className={styles['title-center']}>NET SALES</div>
          </div>
        </div>
      </div>
    );
  }
}

Summary.propTypes = {
  totalTransactions: PropTypes.number,
  totalCollected: PropTypes.number,
  netSales: PropTypes.number,
};

export default Summary;
